import {
  DonationMessage,
  FeedMessageWithMeta,
  HabitatCommentedMessage,
  MediaCommentedMessage,
  MediaCreatedMessage,
  MessageWithMeta,
  QuestionCommentedMessage,
  QuestionCreatedMessage,
  SignUpMessage,
  SponsorMessage,
  SubscriptionMessage,
} from '@/queries/community-feed/types';

import DonationCard from './DonationCard';
import HabitatCommentedCard from './HabitatCommentedCard';
import MediaCommentCreatedCard from './MediaCommentedCard';
import MediaCreatedCard from './MediaCreatedCard';
import QuestionCommentedCard from './QuestionCommentedCard';
import QuestionCreatedCard from './QuestionCreatedCard';
import SignUpCard from './SignUpCard';
import SponsorCard from './SponsorCard';
import SubscriptionCard from './SubscriptionCard';

interface FeedItemProps {
  message: FeedMessageWithMeta;
}

const FeedItem = ({ message: messageWithMeta }: FeedItemProps) => {
  switch (messageWithMeta.message.type) {
    case 'sign-up':
      return <SignUpCard messageWithMeta={messageWithMeta as MessageWithMeta<SignUpMessage>} />;
    case 'subscription':
      return <SubscriptionCard messageWithMeta={messageWithMeta as MessageWithMeta<SubscriptionMessage>} />;
    case 'donation':
      return <DonationCard messageWithMeta={messageWithMeta as MessageWithMeta<DonationMessage>} />;
    case 'habitat-commented':
      return <HabitatCommentedCard messageWithMeta={messageWithMeta as MessageWithMeta<HabitatCommentedMessage>} />;
    case 'media-created':
      return <MediaCreatedCard messageWithMeta={messageWithMeta as MessageWithMeta<MediaCreatedMessage>} />;
    case 'media-commented':
      return <MediaCommentCreatedCard messageWithMeta={messageWithMeta as MessageWithMeta<MediaCommentedMessage>} />;
    case 'question-created':
      return <QuestionCreatedCard messageWithMeta={messageWithMeta as MessageWithMeta<QuestionCreatedMessage>} />;
    case 'question-commented':
      return <QuestionCommentedCard messageWithMeta={messageWithMeta as MessageWithMeta<QuestionCommentedMessage>} />;
    case 'sponsor':
      return <SponsorCard messageWithMeta={messageWithMeta as MessageWithMeta<SponsorMessage>} />;
    default:
      return null;
  }
};

export default FeedItem;
